<template>
  <div>
    <!-- 头部 -->
    <Head></Head>
    <!-- mian -->
    <div>
      <router-view></router-view>
    </div>
    <!-- 尾部 -->
    <Foot></Foot>
  </div>
</template>
<script>
import Head from "../components/head/Head";
import Foot from "../components/foot/Foot";
export default {
  data() {
    return {
      list: {
        mod: "inc",
        act: "ordersys",
        str: "getCategory",
        parent_id: 0
      },
      lists: {}
    };
  },
  methods: {},
  components: {
    Head,
    Foot
  }
};
</script>
<style lang='scss' scoped>
</style>
